import { render, staticRenderFns } from "./AdvertismentPopup.vue?vue&type=template&id=6879ea3f&scoped=true&"
import script from "./AdvertismentPopup.vue?vue&type=script&lang=js&"
export * from "./AdvertismentPopup.vue?vue&type=script&lang=js&"
import style0 from "./AdvertismentPopup.vue?vue&type=style&index=0&id=6879ea3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879ea3f",
  null
  
)

export default component.exports